import { parseDate } from "@certn/utils";
import { UserDetails } from "../types";

export function queryParamsToApiParams(params: Record<string, string>) {
  return {
    page: params.page,
    page_size: params.page_size,
    ordering: params.ordering,
    overall_status: params.overall_status && params.overall_status.split(","),
    check_type: params.check_type && params.check_type.split(","),
    ordered_by: params.ordered_by && params.ordered_by.split(","),
    order_timeframe_after: params.order_timeframe_after,
    order_timeframe_before: params.order_timeframe_before,
    timestamp_after: params.timestamp_after,
    customer_group_id:
      params.customer_group_id && params.customer_group_id.split(","),
    customer_groups:
      params.customer_groups && params.customer_groups.split(","),
    roles: params.roles && params.roles.split(","),
    search: params.search,
    activity_type: params.activity_type && params.activity_type.split(","),
    actor: params.actor && params.actor.split(","),
    is_auth0_blocked:
      params.is_auth0_blocked && params.is_auth0_blocked === "true",
    is_active: params.is_active && params.is_active === "true",
    // Only forward these BooleanFilter params when truthy. The backend
    // short-circuits on False, so omitting the key is the correct way to
    // "not filter" (sending `false` would be a no-op but adds query noise).
    ...(params.is_draft === "true" ? { is_draft: true } : {}),
    ...(params.is_quickscreen === "true" ? { is_quickscreen: true } : {}),
    tag_id: params.tag_id && params.tag_id.split(","),
    package_id: params.package_id && params.package_id.split(","),
    report_result: params.report_result && params.report_result.split(","),
    client_decision:
      params.client_decision && params.client_decision.split(","),
    requestor: params.requestor && params.requestor.split(","),
    apply_link_id: params.apply_link_id && params.apply_link_id.split(","),
    invite_method_email: params.invite_method_email,
    // Legacy case specific parameters
    status: params.status && params.status.split(","),
    report_status: params.report_status && params.report_status.split(","),
    score: params.score && params.score.split(","),
    requested_by: params.requested_by && params.requested_by.split(","),
    checks: params.checks && params.checks.split(","),
    team_type: params.team_type,
    adjudication_status:
      params.adjudication_status && params.adjudication_status.split(","),
  };
}

export function isCustomerAccountActive(userDetails: UserDetails) {
  return userDetails.client_account?.is_active;
}

export function isCustomerAccountVerifiedOrInGracePeriod(
  userDetails: UserDetails
) {
  const validationStatus = userDetails.client_account?.validation_status;

  if (
    validationStatus === "VALIDATED" ||
    validationStatus === "VALIDATED_MANUALLY" ||
    validationStatus === "VALIDATION_NOT_REQUIRED"
  ) {
    return true;
  }

  if (validationStatus === "FAILED_MANUALLY") {
    return false;
  }

  const verificationDeadline = parseDate(
    userDetails.client_account?.validation_deadline
  );

  if (!verificationDeadline) {
    // If no verification required date is set, consider the account verified
    return true;
  }

  if (verificationDeadline > new Date()) {
    // If the verification required date is in the future, the account is considered verified or in grace period
    return true;
  }

  return false;
}
